export const StatCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',
  flex: '1',
  minWidth: 'E',
  StatLabel: { text: (el, s) => s.label, fontSize: 'Y', color: 'inkMuted', fontWeight: '600', textTransform: 'uppercase', letterSpacing: 'X' },
  StatNumber: { text: (el, s) => s.value, fontSize: 'D', fontWeight: '800', color: 'inkText' },
  StatDelta: {
    if: (el, s) => !!s.delta,
    text: (el, s) => s.delta || '',
    fontSize: 'Y',
    fontWeight: '600',
    padding: 'X Y',
    round: 'Y',
    background: (el, s) => (s.delta && s.delta.startsWith('+')) ? 'green.15' : 'red.15',
    color: (el, s) => (s.delta && s.delta.startsWith('+')) ? 'green' : 'red'
  }
}
